/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel surface for the debug-only web-app version override.
 *
 * `isDevToolsBuild` is re-exported here (it physically lives in
 * `src/devtools/`) so the overlay and its hook can gate themselves without
 * reaching outside the viewModel layer, matching how `src/viewModel/navigation`
 * surfaces model-layer navigation primitives.
 */
export { default as appVersionOverrideReducer } from "./appVersionOverrideSlice";
export {
  APPLY_FAILED_MESSAGE,
  INVALID_MOCK_HOST_MESSAGE,
  INVALID_VERSION_MESSAGE,
  MOCK_APPLY_FAILED_MESSAGE,
  applyMockHostOverride,
  applyVersionOverride,
  closeAppVersionOverride,
  focusNextControl,
  focusPrevControl,
  openAppVersionOverride,
  resetMockHostOverride,
  resetVersionOverride,
  selectActiveAppVersion,
  selectActiveMockHost,
  selectAppVersionInput,
  selectAppVersionOverrideError,
  selectAppVersionOverrideFocusedIndex,
  selectIsAppVersionOverrideVisible,
  selectMockHostInput,
  selectMockHostOverrideError,
  setFocusedControl,
  setMockHostInput,
  setVersionInput
} from "./appVersionOverrideSlice";
export {
  APP_VERSION_OVERRIDE_FOCUS_COUNT,
  AppVersionOverrideFocus
} from "./appVersionOverride.types";
export type { AppVersionOverrideState } from "./appVersionOverride.types";
export { isDevToolsBuild } from "../../devtools/appVersionOverride";
